





















































import {Component, Vue, Watch} from 'vue-property-decorator';
import {alertModule, authModule} from "@/store";

@Component
export default class Login extends Vue {
    username: string = process.env.VUE_APP_EXPERT_NAME || "";
    password: string = process.env.VUE_APP_EXPERT_PWD || "";
    showAlert: boolean = false;
    showPassword: boolean = false;
    loading: boolean = false;

    rules: any = {
        validUserName: (value: any) => !value || /^[0-9a-zA-Z_.-]+$/.test(value) ||
            "Benutzername darf nur Zeichen wie 'A-Z', '0-9', '_' oder '-' enthalten",
    }

    get loginFailed(): boolean {
        return authModule.hasFailed;
    }

    @Watch('loginFailed')
    onPropertyChanged(newValue: boolean) {
        this.showAlert = newValue;
    }

    async login() {
        this.loading = true;
        this.showAlert = false;

        const loggedIn = await authModule.login({
            userName: this.username,
            password: this.password
        });
        if (loggedIn) {
            await alertModule.dismissAll();
            await this.$router.push({name: 'home'})
        } else {
            this.showAlert = true;
        }

        this.loading = false;
    }
}
